module.exports = __webpack_public_path__ + "static/media/chapa.7dd7165b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chapa.jpg
// module id = 1291
// module chunks = 0